import * as React from 'react'

import {
  PickersActionBar,
  PickersActionBarProps,
} from '@mui/x-date-pickers/PickersActionBar'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { DatePickerType } from './typings'
import { ENTITY_TYPES } from '@sales-center/common'
export interface CustomBarProps {
  isnextactiondate: DatePickerType
  entitytype?: ENTITY_TYPES
  disabled?: boolean
  setupdateotherdate?: (value: boolean) => void
}

export function CustomActionBar(props: PickersActionBarProps & CustomBarProps) {
  const { isnextactiondate, setupdateotherdate, entitytype, disabled } = props

  const onChangeUpdateOtherDate = React.useCallback(
    (_, checked: boolean) => {
      if (setupdateotherdate) setupdateotherdate(checked)
    },
    [setupdateotherdate],
  )

  return (
    <Box gridRow={3} gridColumn={'1/4'}>
      {entitytype !== ENTITY_TYPES.Lead && (
        <Box paddingLeft={2} sx={{ gridColumn: '1/4', gridRow: '3' }}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                disabled={disabled}
                onChange={onChangeUpdateOtherDate}
              />
            }
            label={`Also make this the ${
              isnextactiondate !== 'expectedclosing'
                ? 'Expected Closing'
                : 'Next Action'
            } Date`}
          />
        </Box>
      )}
      <PickersActionBar {...props} sx={{ gridRow: '4' }} />
    </Box>
  )
}
